import Base from "./Base"
import Store from "./Store"
import Ajax from "./Ajax"

class Accessibility extends Base {
	/**
	 * Init
	 */
	ready() {
		this.trackKeyBoardPress();
		this.handleAnimation();
		setTimeout(() => {
			this.updateVisitor();
		}, 10000)

		if (!this.isPremium) return;
		this.initLargeFont();
		this.checkLargeFont();
	}

	/**
	 * Track keyboard press
	 */
	trackKeyBoardPress() {

		// Bail, if accessibility is disabled.
		if (!wp_dark_mode_json.options.accessibility_enabled_keyboard_shortcut) {
			return;
		}

		document.addEventListener('keydown', (e) => {
			// if pressed ctrl + alt + d
			if (e.ctrlKey && e.altKey && e.keyCode === 68) {
				WPDarkMode.toggle().remember();
			}
		});
	}

	/**
	 * Handle animation
	 */
	handleAnimation() {
		// Bail if animation_enabled is disabled.
		if (!wp_dark_mode_json.options.animation_enabled) {
			return;
		}

		// Add animation class.
		if (WPDarkMode.isActive) {
			document.querySelector('html').classList.add('wp-dark-mode-animation');
		}

		WPDarkMode.onChange(() => {
			if (!WPDarkMode.isActive) {
				document.querySelector('html').classList.remove('wp-dark-mode-animation');
			} else {
				document.querySelector('html').classList.add('wp-dark-mode-animation');
			}
		})

	}

	/**
	 * Init large font
	 */
	initLargeFont = () => {
		if (!wp_dark_mode_json.options.typography_enabled) return;


		const elements = document.querySelectorAll('*:not(.wp-dark-mode-ignore):not(.wp-dark-mode-switch):not(script):not(style):not(link):not(meta):not(title):not(base):not(head):not(.wp-dark-mode-switch)');

		let desiredSize = wp_dark_mode_json.options.typography_font_size;
		if (desiredSize === 'custom') {
			desiredSize = wp_dark_mode_json.options.typography_font_size_custom / 100;
		}

		elements.forEach(element => {
			// Bail, if any of parent has wp-dark-mode-ignore class.
			if (element.closest('.wp-dark-mode-ignore')) {
				return;
			}

			const fontSize = getComputedStyle(element).fontSize;

			if (fontSize) {
				// Calculate new font size
				const newFontSize = this.calculateFontSize(fontSize, desiredSize);

				// Set property
				element.style.setProperty('--wpdm-large-font-size', newFontSize);
			}
		});
	}

	/**
	 * Toggle font size
	 */
	toggleFontSize(element) {

		if (!wp_dark_mode_json.options.typography_enabled) return;

		const html = document.querySelector('html');

		// Is large font is active
		const isLargeFont = html.classList.contains('wp-dark-mode-large-font');

		// Toggle large font
		html.classList[isLargeFont ? 'remove' : 'add']('wp-dark-mode-large-font');

		// Is element is 
		const isActive = element.classList.contains('active');
		const newIsActive = !isActive;

		// Toggle active class
		element.classList[isActive ? 'remove' : 'add']('active');

		// Use plain button role with NO state attributes to prevent announcements
		element.setAttribute('role', 'button');
		element.removeAttribute('aria-checked');
		element.removeAttribute('aria-pressed');
		
		// Only set aria-label once on initialization, don't change it
		if (!element.getAttribute('aria-label')) {
			element.setAttribute('aria-label', 'Toggle Font Size');
		}

		// Announce via aria-live region
		const stateLabel = newIsActive ? 'Large Font On' : 'Normal Font On';
		const announcer = document.getElementById('wp-dark-mode-announcer');
		if (announcer) {
			announcer.textContent = '';
			setTimeout(() => {
				announcer.textContent = stateLabel;
			}, 50);
		}

		// Remember user choice
		Store.set('large-font', !isLargeFont ? 'on' : 'off');

		// Reactive other switches
		const switches = document.querySelectorAll('.wp-dark-mode-switch ._font');

		if (!switches || !switches.length) return;

		switches.forEach(switchEl => {
			switchEl.classList[isActive ? 'remove' : 'add']('active');
			switchEl.setAttribute('role', 'button');
			switchEl.removeAttribute('aria-checked');
			switchEl.removeAttribute('aria-pressed');
			
			// Only set aria-label once on initialization, don't change it
			if (!switchEl.getAttribute('aria-label')) {
				switchEl.setAttribute('aria-label', 'Toggle Font Size');
			}
		});

	}


	calculateFontSize = (size, by = 1) => {
		const unit = size.replace(/[0-9]/g, '');
		const value = parseFloat(size.replace(/[a-z]/g, ''));

		let newValue = 0;
		newValue = value * by;
		return `${newValue}${unit}`;
	}

	/**
	 * Check large font
	 */
	checkLargeFont = () => {

		const isLargeFont = Store.get('large-font') === 'on';

		if (isLargeFont) {
			document.querySelector('html').classList.add('wp-dark-mode-large-font');

			// On wp-dark-mode-switches-updated event
			document.addEventListener('wp-dark-mode-switches-updated', () => {
				const switches = document.querySelectorAll('.wp-dark-mode-switch ._font');
				if (!switches || !switches.length) return;
				switches.forEach(switchEl => {
					switchEl.classList.add('active');
					switchEl.setAttribute('role', 'button');
					switchEl.removeAttribute('aria-checked');
					switchEl.removeAttribute('aria-pressed');
					
					// Only set aria-label once on initialization, don't change it
					if (!switchEl.getAttribute('aria-label')) {
						switchEl.setAttribute('aria-label', 'Toggle Font Size');
					}
				});
			});
		} else {
			// When large font is OFF, ensure switches reflect that
			document.addEventListener('wp-dark-mode-switches-updated', () => {
				const switches = document.querySelectorAll('.wp-dark-mode-switch ._font');
				if (!switches || !switches.length) return;
				switches.forEach(switchEl => {
					switchEl.classList.remove('active');
					switchEl.setAttribute('role', 'button');
					switchEl.removeAttribute('aria-checked');
					switchEl.removeAttribute('aria-pressed');
					
					// Only set aria-label once on initialization, don't change it
					if (!switchEl.getAttribute('aria-label')) {
						switchEl.setAttribute('aria-label', 'Toggle Font Size');
					}
				});
			});
		}
	}


	/**
	 * Track visitor
	 */
	async updateVisitor() {
		// Bail, if analytics is disabled.
		if (!wp_dark_mode_json.analytics_enabled) {
			return;
		}

		// Bail, if user has already visited.
		if (localStorage.getItem('wp-dark-mode-visitor')) {
			// return;
		}

		// Set visitor.
		const visitor_id = localStorage.getItem('wp-dark-mode-visitor') || null;
		// Log('visitor_id', visitor_id);

		const payload = {
			visitor_id: visitor_id || false,
			mode: WPDarkMode.isActive ? 'dark' : 'light',
			security_key: wp_dark_mode_json.security_key,
			website: '', // Honeypot.
		};

		if (!visitor_id) {

			// For new visitors, send meta data.
			payload.meta = JSON.stringify({
				os: navigator.platform,
				browser: navigator.appCodeName,
				browser_version: navigator.appVersion,
				language: navigator.language,
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
			})?.replace(';', '');

			try {
				payload.ip = await fetch('https://api.ipify.org?format=json').then(response => response.json()).then(data => data.ip);
			} catch (error) { }
		}

		// Send request.
		const result = await Ajax.post('wp_dark_mode_update_visitor', payload);

		// Set visited.
		if (result && result.success && !visitor_id) {
			localStorage.setItem('wp-dark-mode-visitor', result.data.visitor_id);
		}
	}
}

export default new Accessibility();